export type TitleH1ContainerProps = {
  title: string;
  type: CourseTitleType;
};

export enum CourseTitleType {
  h1 = 'h1',
  h3 = 'h3',
}
